<template>
  <v-dialog
    v-model="dialog"
    transition="dialog-bottom-transition"
    persistent
    :overlay-opacity="1"
    content-class="ageReminder"
    overlay-color="grey-3"
  >
    <v-card dark>
      <v-container>
        <div>
          <span class="title font-weight-bold">PnBHouse</span> 提供付費瀏覽的影音社交平台和購物平台，用戶可以通過建立帳號，發佈照片、動態、影片和商品。
          當您註冊、登入或使用本平台任何功能時，即表示您已詳細審閱並同意完全遵守本平台的服務條款，且接受相關規範：
        </div>
        <ul class="px-12 py-4">
          <li>您已年滿十八歲。</li>
          <li>您只能限於在本網站中瀏覽內容，且不會分享或下載內容到本網站之外的地方。</li>
          <li>您於本網站內創作的內容，不會違反服務條款或任何法律。包含暴力、犯罪、歧視等不適當內容。</li>
        </ul>
        <div>
          本平台對於所提供之服務，除本條款或其他會員相關規範另有規定者外，對其各類服務並不提供任何明示默示的擔保，包括但不限於商業適用性、特定目的之適用性及未侵害他人權益。
        </div>
        <div class="text-center">
          <v-btn rounded large color="pink darken-1" class="mt-8 mb-5 px-8" @click="dialog = false; isLogin ? '' : $router.push('/login')">我已閱讀並同意遵守</v-btn><br>
          <strong class="red--text text--darken-1">警告！未滿十八歲者禁止進入</strong><br>
          繼續登入，代表您同意
          <a href="/terms" target="_blank">服務條款</a>
          及
          <a href="/policy" target="_blank">隱私權政策</a>
        </div>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
  data() {
    return {
      dialog: true
    }
  },
  created() {
    if(['Terms', 'Policy'].includes(this.$route.name) || this.$func.inAdminPortal() || this.$func.inSellerPortal()) {
      this.dialog = false
    }
  },
  mounted() {
    document.body.style.overflow = 'hidden'
  },
  computed: {
    ...mapGetters('user', ['isLogin'])
  },
  watch: {
    dialog(newValue) {
      if(newValue) {
        document.body.style.overflow = 'hidden'
      }
      else {
        document.body.style.overflow = 'auto'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.v-overlay {
  transition: none;
}
.ageReminder {
  margin: 0;
  position: fixed;
  left: 0;
  bottom: 0;
  box-shadow: none;
  font-weight: 300;
  font-size: 14px;
  .v-card {
    background-color: $grey-4;
    line-height: 2;
    padding: 24px 0;
    strong {
      font-weight: bold;
      font-size: 24px;
    }
    a {
      color: $main !important;
    }
  }
}
</style>